// Ensures form elements are all the same heights
export default {
  xs: "24px",
  sm: "32px",
  md: "40px",
  lg: "48px",
};
